import { Link } from 'react-router-dom'

const Public = () => {
    const content = (
        <section className="public">
            <header>
                <h1>Welcome to <span className="nowrap">geshtop-Exercise App</span></h1>
            </header>
            <main className="public__main he">
                <p>ממשק עזר לתלמיד ולמורה בו ניתן יהיה להכניס את המשימות, לעקוב אחר המשימות וכן אפשר לקבל משוב על אופי המשימה והציון</p>
                
                <address className="public__addr">
                    פותח ע"י: <br />
                    גאולה שושן<br />
                   
                </address>
                <br />
            </main>
            <footer className="public__footer">
                
                <Link to="/login">כניסת משתמשים</Link>
                <p>&copy; 2023 כל הזכויות שמורות   </p>

            </footer>
        </section>

    )
    return content
}
export default Public